import { SpotPricePoint } from '.';
import { Moment, getCSSCustomProp } from '@tools/utils';

export const getSpotPriceColors = () => ({
    grey: getCSSCustomProp('color-grey'),
    white: getCSSCustomProp('color-white'),
    darkest: getCSSCustomProp('color-darkest'),
    darkgrey: getCSSCustomProp('color-darkgrey'),
    lightgrey: getCSSCustomProp('color-lightgrey'),
    turquoise: getCSSCustomProp('color-turquoise'),
    limeyellow: getCSSCustomProp('color-limeyellow'),
});

export const getIntervalPeriod = (data: SpotPricePoint[]): number => {
    if (data.length === 0) {
        return 0;
    }

    return Moment(data?.[1]?.x).diff(data?.[0]?.x, 'minutes');
};

export const addIntervalToSpotPriceEntry = (
    data: SpotPricePoint,
    timezone: string,
    interval = 60,
): SpotPricePoint => ({
    ...data,
    x: Moment(data.x).add(interval, 'minutes').tz(timezone).format(),
});

export const shouldHideFlyout = (
    index: string | number | undefined,
    dataLength: number,
): boolean => {
    if (typeof index === 'undefined') {
        return true;
    }

    return Number(index) >= dataLength - 1;
};
